import { render, staticRenderFns } from "./RecommendItemDetail.vue?vue&type=template&id=6740f406&"
import script from "./RecommendItemDetail.vue?vue&type=script&lang=js&"
export * from "./RecommendItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports